export default __webpack_public_path__ + "static/media/logo.949d15cc.png";